import React, { Component} from "react";

class Contact extends Component{
    render(){
        return(
             <article className="contact-panel" data-panel="contact">
                                <header className="panel-head">
                                    <h2 data-en="Contact" data-fa="تماس">Contact</h2>
                                    <span className="head-line"></span>
                                </header>
                                <div className="contact-grid">
                                    <div className="contact-info">
                                        <div className="ci">
                                            <i className="bi bi-geo-alt">
                                            </i>
                                            <span data-en="yazd, Iran" data-fa="ایران ،یزد">
                                                yazd, Iran
                                            </span>
                                        </div>
                                        <div className="ci">
                                            <i className="bi bi-envelope"></i>
                                            <a className="info-v-email-call" href="mailto:sftmhzare@gmail.com">
                                                sftmhzare@gmail.com
                                            </a>
                                        </div>
                                        <div className="ci">
                                            <i className="bi bi-telephone">
                                            </i>
                                            <a
                                                href="tel:+989134579048"
                                                dir="ltr"
                                                type="tel"
                                                className="phon">
                                                +98 913 457 9048
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </article>
        );
    }
}

export default Contact;